module.exports = "<payment-methods-page></payment-methods-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/paymentMethodsView.html
// module id = 2192
// module chunks = 0